export const unwrapApiResponse = (response) => {
  const body = response.data;

  if (body && typeof body.success === "boolean") {
    if (!body.success) {
      const detail =
        Array.isArray(body.errors) && body.errors.length > 0
          ? body.errors.join(" ")
          : "";
      const error = new Error(body.message || "Request failed");
      error.errors = body.errors || [];
      error.status = response.status;
      if (detail) error.message = detail ? `${body.message} ${detail}`.trim() : body.message;
      throw error;
    }
    return body.data;
  }

  // Public content endpoints return the DTO directly (no envelope)
  return body;
};

export const getApiErrorMessage = (error) => {
  const data = error?.response?.data;
  if (data?.message) {
    if (Array.isArray(data.errors) && data.errors.length > 0) {
      return `${data.message} ${data.errors.join(" ")}`.trim();
    }
    return data.message;
  }
  return error?.message || "Something went wrong.";
};
